export const robocallReductionSubsectionNavMixin = {
  computed: {
    subSectionNav() {
      return [
        { to: { name: 'admin_configurations_robocall_reduction' }, label: 'Configuration' },
        { to: { name: 'admin_robocall_reduction_notifications' }, label: 'Alerts' }
      ]
    }
  }
}
